import React from 'react';

import { STREAM_QUALITY_OPTIONS } from '@vlabs/monokit/shared/lib/video';
import { DropdownMenu } from '@vlabs/uikit';
import { SelectButtonMonochoice } from '@vlabs/uikit/components/controls/select-button-monochoice/SelectButtonMonochoice';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { useSourceLivePageTranslation } from '../i18n';
import { useRestream } from '../restream-context';

export const ORIGINAL_QUALITY = 'original';

// Селектор качества ретрансляции: самодостаточен — качество и его смена
// берутся из контекста ретрансляции (общие для шапки и fullscreen-панели).
function StreamQualitySelect({
  'data-testid': dataTestId = undefined,
}: WithDataTestid): React.JSX.Element {
  const { t } = useSourceLivePageTranslation();
  const { quality, setQuality, originalQuality } = useRestream();

  let originalLabel = t('quality_original');
  if (originalQuality !== undefined) {
    originalLabel = t('quality_original_value', { quality: originalQuality });
  }

  const options = [
    { value: ORIGINAL_QUALITY, label: originalLabel },
    ...STREAM_QUALITY_OPTIONS.map((value) => ({
      value: String(value),
      label: t(`quality_${value}`),
    })),
  ];

  const selectedValue = quality === undefined ? ORIGINAL_QUALITY : String(quality);

  const handleSelect = (value: string) => {
    if (value === ORIGINAL_QUALITY) {
      setQuality(undefined);
      return;
    }
    setQuality(Number(value));
  };

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger
        render={(props, state) => (
          <SelectButtonMonochoice
            {...props}
            data-testid={dataTestId}
            isOpen={state.open}
            value={options.find((option) => option.value === selectedValue)?.label}
            variant="outlined"
          />
        )}
      />
      <DropdownMenu.Portal>
        <DropdownMenu.Positioner style={{ zIndex: 60 }}>
          <DropdownMenu.Popup>
            {options.map((option) => (
              <DropdownMenu.CheckboxItem
                checked={option.value === selectedValue}
                closeOnClick
                key={option.value}
                onCheckedChange={() => handleSelect(option.value)}
              >
                {option.label}
              </DropdownMenu.CheckboxItem>
            ))}
          </DropdownMenu.Popup>
        </DropdownMenu.Positioner>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

export { StreamQualitySelect };
